import { render, staticRenderFns } from "./AllRequests.vue?vue&type=template&id=b0b4fa1e&scoped=true&"
import script from "./AllRequests.vue?vue&type=script&lang=js&"
export * from "./AllRequests.vue?vue&type=script&lang=js&"
import style0 from "./AllRequests.vue?vue&type=style&index=0&id=b0b4fa1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b4fa1e",
  null
  
)

export default component.exports